import {useMemo} from 'react';

import {
  ArtifactSequence,
  useEntityArtifactsOfTypeQuery,
} from '../../../generated/graphql';
import {DEFAULT_LAUNCH_PROJECT_NAME} from '../../../pages/EntityLaunchPage';
import {getJobDetails} from '../JobDetail/hooks';
import {JobDetails} from '../JobDetail/utilTypes';

// Derive job details from list of job artifact sequences
// from the gql result
export function useJobDetailsOptions(entityName: string, projectName: string) {
  const isInEntityLaunchProject = projectName === DEFAULT_LAUNCH_PROJECT_NAME;
  const {
    data: jobArtifacts,
    loading,
    error,
  } = useEntityArtifactsOfTypeQuery({
    variables: {entityName, artifactType: 'job'},
  });

  const projects = jobArtifacts?.entity?.projects;

  const jobDetailsMap: Record<string, JobDetails> = useMemo(() => {
    const jobDetailsTuples: Array<[string, JobDetails]> = [];
    projects?.edges.forEach(project => {
      const artifactSequences = project.node?.artifactType?.artifactSequences;
      artifactSequences?.edges.forEach(artifactSequence => {
        const jobDetails = getJobDetails(
          artifactSequence.node as ArtifactSequence
        );
        // Push jobs into the map based on project/entity scope
        if (isInEntityLaunchProject) {
          jobDetailsTuples.push([
            `${project.node?.name}/${jobDetails.name}`,
            jobDetails,
          ]);
        } else if (
          !isInEntityLaunchProject &&
          project.node?.name === projectName
        ) {
          jobDetailsTuples.push([jobDetails.name, jobDetails]);
        }
      });
    });
    return Object.fromEntries(jobDetailsTuples);
  }, [isInEntityLaunchProject, projects?.edges, projectName]);

  if (!projects || loading || error || projects.edges.length === 0) {
    return {data: {} as Record<string, JobDetails>, loading, error};
  }
  return {
    data: jobDetailsMap,
    loading: false,
    error: null,
  };
}
